import { render, staticRenderFns } from "./ArticleWrapper.vue?vue&type=template&id=6bb6b77e"
import script from "./ArticleWrapper.vue?vue&type=script&lang=js"
export * from "./ArticleWrapper.vue?vue&type=script&lang=js"
import "./ArticleWrapper.vue?vue&type=style&index=0&id=6bb6b77e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports